










































import { Component, Vue } from 'vue-property-decorator';

import EditReminderSuccessModelViewModel from '@/vue-app/view-models/components/kuspit-dashboard/edit-reminder/edit-reminder-success-model-view-model';

@Component({
  name: 'EditReminderSuccessModal',
})
export default class EditReminderSuccessModal extends Vue {
  edit_reminder_success_modal_model = Vue.observable(
    new EditReminderSuccessModelViewModel(this),
  );
}
